import React from "react";
import theme from "../../../styles/theme";



const Page24 = () => {
  return (

 
   <div>
    <h2>"Page 24" </h2>
    </div>


  );
};

export default Page24;
